import { Link } from "react-router-dom";
import { TrendingUp, Bomb, Target, Infinity as InfinityIcon, Lock, Building2 } from "lucide-react";

const GAMES = [
  { id: "crash", name: "CRASH", icon: TrendingUp, status: "LIVE", cls: "border-brand-magenta text-brand-magenta", desc: "Multiplayer PvP curve. Cash out before it crashes.", to: "/game" },
  { id: "limbo", name: "LIMBO", icon: InfinityIcon, status: "LIVE", cls: "border-brand-cyan text-brand-cyan", desc: "Pick a target multiplier, instant result.", to: "/limbo" },
  { id: "tower", name: "TOWER", icon: Building2, status: "LIVE", cls: "border-brand-magenta text-brand-magenta", desc: "Pick the safe tile, climb 8 floors, cash out anytime.", to: "/tower" },
  { id: "plinko", name: "PLINKO", icon: Target, status: "COMING", cls: "border-white/20 text-white/40", desc: "Falling ball, multiplier buckets up to 1000×.", to: null },
  { id: "mines", name: "MINES", icon: Bomb, status: "COMING", cls: "border-white/20 text-white/40", desc: "5×5 grid, dodge the mines, stack multipliers.", to: null },
];

export default function GameHub() {
  return (
    <div className="max-w-6xl mx-auto p-4 sm:p-6 lg:p-10" data-testid="game-hub-page">
      <div className="label-mono mb-3">// game_worlds</div>
      <h1 className="font-display font-black text-3xl lg:text-5xl tracking-tighter mb-2">PICK YOUR GAME.</h1>
      <p className="text-white/60 font-body mb-10">One wallet, five games. Start anywhere.</p>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 lg:gap-5">
        {GAMES.map((g) => {
          const Icon = g.icon;
          const live = g.status === "LIVE";
          const Wrapper = live ? Link : "div";
          const props = live ? { to: g.to } : {};
          return (
            <Wrapper key={g.id} {...props} className={`panel panel-glow p-6 relative overflow-hidden group transition-transform ${live ? "hover:-translate-y-1 cursor-pointer" : "opacity-60"}`} data-testid={`hub-game-${g.id}`}>
              <div className="flex items-center gap-4 mb-4">
                <div className={`w-14 h-14 border-2 grid place-items-center shrink-0 ${g.cls}`}>
                  <Icon className="w-7 h-7" strokeWidth={2} />
                </div>
                <div className="flex-1">
                  <h3 className="font-display font-black text-2xl lg:text-3xl tracking-tighter leading-none">{g.name}</h3>
                </div>
                {live ? (
                  <span className="label-mono text-brand-magenta border border-brand-magenta/60 px-2 py-1 flex items-center gap-1.5 shrink-0">
                    <span className="dot-live" /> LIVE
                  </span>
                ) : (
                  <span className="label-mono text-white/40 border border-white/15 px-2 py-1 flex items-center gap-1.5 shrink-0">
                    <Lock className="w-3 h-3" /> SOON
                  </span>
                )}
              </div>
              <p className="text-white/60 font-body text-sm">{g.desc}</p>
              {live && (
                <div className="mt-3 label-mono text-brand-magenta group-hover:translate-x-1 transition-transform inline-block">
                  enter →
                </div>
              )}
            </Wrapper>
          );
        })}
      </div>
    </div>
  );
}
